// extracted by mini-css-extract-plugin
module.exports = {"gridLayout":"master_gridLayout__2gjrH","menu":"master_menu__1XJ11","backgroundContainer":"master_backgroundContainer__3x3JD"};